interface TwoPersonIconProps {
  color?: string;
  className?: string;
  onClick?: () => void;
  size?: number;
}
function TwoPersonIcon({
  color,
  className,
  onClick,
  size,
}: TwoPersonIconProps) {
  return (
    <svg
      width={size || 40}
      height={size || 40}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M41.25 49.998V44.924C41.25 41.8183 39.8517 38.7728 37.0257 37.4845C33.5787 35.9133 29.4447 34.998 25 34.998C20.5553 34.998 16.4212 35.9133 12.9742 37.4845C10.1482 38.7728 8.75 41.8183 8.75 44.924V49.998"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.25 50.0005V44.9262C51.25 41.8205 49.8518 38.7752 47.0258 37.487C46.3743 37.19 45.698 36.9162 45 36.668"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 27.502C29.8325 27.502 33.75 23.5844 33.75 18.752C33.75 13.9195 29.8325 10.002 25 10.002C20.1675 10.002 16.25 13.9195 16.25 18.752C16.25 23.5844 20.1675 27.502 25 27.502Z"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 10.3594C41.1143 11.4351 43.75 14.7833 43.75 18.747C43.75 22.7108 41.1143 26.0591 37.5 27.1348"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TwoPersonIcon;
